import connection from "./connection";
import axios from "axios";
import {AdjusmentNoteRequest, AdjustmentNoteReq, AdjutsmentNoteCategoryReq} from 'libs/shared-models/finance/src'
import { CommonResponse } from "@gtpl/shared-models/masters";

export class AdjustmentNoteService{
    URL = connection.DEPLOY_URL + '/adjustmentNotes';

    async createAdjustmentNote(request: AdjustmentNoteReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createAdjustmentNote', request)
            .then(res => {
                return res.data
            })
    }
 
    async getAllPrintInfo(request: AdjusmentNoteRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllPrintInfo', request)
            .then(res => {
                return res.data
            })
    }

    async getAdjustmentNoteInfo(request: AdjutsmentNoteCategoryReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAdjustmentNoteInfo', request)
            .then(res => {
                return res.data
            })
    }

    async getNoteNumberDropDown(request: AdjutsmentNoteCategoryReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getNoteNumberDropDown', request)
            .then(res => {
                return res.data
            })
    }

    async getInvoiceNumberDropDown(request: AdjutsmentNoteCategoryReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getInvoiceNumberDropDown', request)
            .then(res => {
                return res.data
            })
    }

    async getVendorDropDown(request: AdjutsmentNoteCategoryReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getVendorDropDown', request)
            .then(res => {
                return res.data
            })
    }

}